import * as React from 'react';
import { Form_MultilineStringInputProps } from '../../../../../../react-commons/components/form/inputs/Form_MultilineStringInput';
import { Inputs } from '../../../../../../react-commons/utils/form/inputs';
import { usePropertyInfo } from '../../../hooks/usePropertyInfo';
import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';

export const Form_PropertyMultilineInput = <T extends object, N extends boolean>({
    readOnly,
    nullable,
    labelOverride,
    propertyValidationInformation: { propertyIdentifier, resourceType, resourceId },
    hideLabel,
    ...props
}: Omit<Form_MultilineStringInputProps<T, N>, 'label' | 'labelInfo' | 'severity' | 'helperText'> & {
    labelOverride?: string;
    propertyValidationInformation: PropertyValidationInformation;
    hideLabel?: boolean;
}) => {
    const propertyInfo = usePropertyInfo({
        propertyIdentifier,
        resourceType,
        resourceId,
        hideLabel,
        labelOverride,
        readOnly,
    });

    return <Inputs.MultilineString
        nullable={nullable}
        {...propertyInfo}
        {...props}
        helperText={propertyInfo.helperText ? [propertyInfo.helperText] : undefined}
    />;
};
